import { render, staticRenderFns } from "./bigSort.vue?vue&type=template&id=3feb126d"
import script from "./bigSort.vue?vue&type=script&lang=js"
export * from "./bigSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports